import React, {
  useContext,
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import { DF_OT0050Context } from "../context";
import { Row, Modal } from "reactstrap";
import TableSimple from "../../../components/Dynamic/TableSimple";
import ModalIframePage from "../../../components/Common/ModalIframePage";
import DF_OT0052 from "../DF_OT0052/Grid/GridBody";

export default function GridBody() {
  const {
    userProfile,
    paramsOnFilter,
    triggerOnFilter,
    setTriggerOnFilter,
    inputGlobalSearchValue,
    setFilteredData,
    isOpenModalNuevo,
    setIsOpenModalNuevo,
  } = useContext(DF_OT0050Context);

  const navigate = useNavigate();

  const [triggerType, setTriggerType] = useState(null);
  const [openModalVisualization, setOpenModalVisualization] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const filteredDataRef = useRef([]);

  const handleCloseModalVisualization = useCallback(() => {
    setOpenModalVisualization(false);
    setTriggerType(null);
    setSelectedRowData(null);
    setTriggerOnFilter(true);
  }, [setTriggerOnFilter]);

  const handleModalIframeClosed = useCallback(() => {
    handleCloseModalVisualization();
  }, [handleCloseModalVisualization]);

  const handleFilteredDataChange = useCallback(
    (data) => {
      filteredDataRef.current = data || [];
      setFilteredData(data);
    },
    [setFilteredData],
  );

  const handleTriggers = useCallback(
    (trigger) => {
      const rowId = (() => {
        if (trigger?.params) {
          const match = trigger.params.match(/ID_Local_Entrega=(\d+)/);
          if (match) return match[1];
        }
        return (
          trigger?.key ?? trigger?.id ?? trigger?.row_id ?? trigger?.ID ?? null
        );
      })();

      const rowData =
        rowId != null
          ? filteredDataRef.current?.find(
              (row) => String(row.ID) === String(rowId),
            )
          : null;

      if (trigger?.transaction_id?.includes("DF_OT0053")) {
        navigate("/DF_OT0053", { state: { rowData } });
        return;
      }

      if (rowData) {
        setSelectedRowData(rowData);
        const extraParams = new URLSearchParams({
          ID: rowData.ID ?? "",
          CNPJ_Local_Entrega: rowData.CNPJ_Local_Entrega ?? "",
          Descricao_Local_Entrega: rowData.Descricao_Local_Entrega ?? "",
          Horario_Inicio: rowData.Horario_Inicio ?? "",
          Horario_Termino: rowData.Horario_Termino ?? "",
          Limite_Diario_Max_Volumes: rowData.Limite_Diario_Max_Volumes ?? "",
          Limite_Diario_Max_Valor: rowData.Limite_Diario_Max_Valor ?? "",
          Limite_Diario_Max_Peso: rowData.Limite_Diario_Max_Peso ?? "",
          Limite_Diario_Max_Veiculos: rowData.Limite_Diario_Max_Veiculos ?? "",
          Limite_Max_Horario_Prog_Agendamento:
            rowData.Limite_Max_Horario_Prog_Agendamento ?? "",
          Limite_Min_Dias_Prog_Agendamento:
            rowData.Limite_Min_Dias_Prog_Agendamento ?? "",
          Limite_Max_Dias_Prog_Agendamento:
            rowData.Limite_Max_Dias_Prog_Agendamento ?? "",
          Limite_Agendamentos_Diarios_Parceiro:
            rowData.Limite_Agendamentos_Diarios_Parceiro ?? "",
          Data_Encerramento: rowData.Data_Encerramento ?? "",
          Observacao: rowData.Observacao ?? "",
          Mostra_Horario: rowData.Mostra_Horario ?? "",
          ID_Log: rowData.ID_Log ?? "",
        }).toString();

        setTriggerType({
          ...trigger,
          params: trigger?.params
            ? `${trigger.params}&${extraParams}`
            : extraParams,
        });
      } else {
        setTriggerType(trigger);
      }

      setOpenModalVisualization(true);
    },
    [navigate],
  );

  const idEmpresaSelecionada = useMemo(() => {
    if (!paramsOnFilter || paramsOnFilter.length === 0) return null;
    const primeiroFiltro = paramsOnFilter[0];

    if (primeiroFiltro?.Filtro_ID_Empresa?.value) {
      return primeiroFiltro.Filtro_ID_Empresa.value;
    }

    const chaves = Object.keys(primeiroFiltro);
    if (chaves.length > 0) {
      return primeiroFiltro[chaves[0]]?.value ?? null;
    }

    return null;
  }, [paramsOnFilter]);

  useEffect(() => {
    if (isOpenModalNuevo) {
      setIsOpenModalNuevo(false);
      navigate("/DF_OT0051", { state: { idEmpresa: idEmpresaSelecionada } });
    }
  }, [isOpenModalNuevo, navigate, idEmpresaSelecionada, setIsOpenModalNuevo]);

  const columnsList = useMemo(
    () => [
      { field: "ID", header: "ID", width: "5%", sort: true },
      { field: "CNPJ_Local_Entrega", header: "CNPJ Local Entrega", sort: true },
      { field: "Descricao_Local_Entrega", header: "Descrição", sort: true },
      { field: "Horario_Inicio", header: "Horário Início", sort: true },
      { field: "Horario_Termino", header: "Horário Final", sort: true },
      {
        field: "Coluna_Funcoes",
        header: "",
        width: "5%",
        hasImage: true,
        Export: false,
      },
    ],
    [],
  );

  const isCancelamento = triggerType?.transaction_id?.includes("DF_OT0052");

  const stringParams = useMemo(() => {
    const idUsuario = userProfile?.ID_Usuario || 0;
    const valorEmpresa =
      idEmpresaSelecionada !== null ? `"${idEmpresaSelecionada}"` : "null";
    return `[ "${idUsuario}", "pt-BR", "1", "10", ${valorEmpresa} ]`;
  }, [userProfile, idEmpresaSelecionada]);

  return (
    <React.Fragment>
      <Row>
        <TableSimple
          dataKey={"ID"}
          procName={"FRONT_Workspace_DF_OT0050_Tabela_Grid_V16"}
          procParams={stringParams}
          columnsList={columnsList}
          paramsOnFilter={paramsOnFilter}
          triggerOnFilter={triggerOnFilter}
          setTriggerOnFilter={setTriggerOnFilter}
          inputSearchValue={inputGlobalSearchValue}
          enableDataSharing={true}
          onFilteredDataChange={handleFilteredDataChange}
          callbackTriggers={handleTriggers}
        />

        {isCancelamento ? (
          <Modal
            className="modal-dialog-centered modal-custom-style rounded"
            isOpen={openModalVisualization}
            toggle={handleCloseModalVisualization}
            centered
          >
            <DF_OT0052
              rowData={selectedRowData}
              onClose={handleCloseModalVisualization}
              onCancelSuccess={handleCloseModalVisualization}
            />
          </Modal>
        ) : (
          <ModalIframePage
            openModal={openModalVisualization}
            onClosed={handleModalIframeClosed}
            triggerType={triggerType}
          />
        )}
      </Row>
    </React.Fragment>
  );
}